module.exports = __webpack_public_path__ + "img/desktop_pipeline_top_img.88f2305a.jpg";